{
  "name": "@psu-pennstateit-swe/college-cost-admin",
  "version": "0.0.0",
  "license": "UNLICENSED",
  "scripts": {
    "build": "ng build",
    "ci:release": "semantic-release",
    "ci:test": "ng test --configuration ci",
    "cy:open": "ng run college-cost-admin:cypress-open",
    "cy:run": "ng run college-cost-admin:cypress-run",
    "cz": "czg",
    "e2e": "ng e2e",
    "lint": "ng lint",
    "ng": "ng",
    "prepare": "husky",
    "start": "ng serve",
    "test": "ng test"
  },
  "dependencies": {
    "@angular/animations": "^20.3.26",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/forms": "^20.3.26",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@mdi/angular-material": "^7.2.96",
    "@psu-pennstateit-swe/apis": "^28.1.0",
    "@psu-pennstateit-swe/palette": "^5.0.6",
    "@psu-pennstateit-swe/theme-lib": "^8.1.1",
    "@psu-pennstateit-swe/utils": "^10.2.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.32",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.26",
    "@cypress/schematic": "^5.0.0",
    "@psu-pennstateit-swe/config": "^5.1.1",
    "@psu-pennstateit-swe/eslint-config": "^5.1.1",
    "@psu-pennstateit-swe/prettier-config": "^5.1.1",
    "@semantic-release/exec": "^7.1.0",
    "@types/jasmine": "~5.1.0",
    "@types/luxon": "^3.7.1",
    "cypress": "15.15.0",
    "cz-git": "^1.13.1",
    "eslint-plugin-only-warn": "^1.1.0",
    "git-branch-is": "^4.0.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.4",
    "karma-brief-reporter": "^0.2.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "karma-junit-reporter": "^2.0.1",
    "lint-staged": "^17.0.4",
    "luxon": "^3.7.2",
    "semantic-release": "^25.0.8",
    "ts-mocks": "^3.0.1",
    "typescript": "~5.9.3"
  },
  "publishConfig": {
    "@psu-pennstateit-swe:registry": "https://npm.pkg.github.com"
  }
}
